import { Button } from '@/components/ui/button'
import type { useCobaltProviderDiscovery } from './useCobaltProviderDiscovery'

export function CobaltProviderDiscoveryStatus({
  discovery,
  message,
  locked,
  onRestart,
}: {
  discovery: ReturnType<typeof useCobaltProviderDiscovery>
  message: string
  locked: boolean
  onRestart: () => void
}) {
  return (
    <>
      {discovery.busy && (
        <p role="status" className="text-sm text-muted-foreground">
          Cobalt is refreshing the directory. This can take a few minutes.
        </p>
      )}
      {discovery.needsCheck && (
        <div role="alert" className="text-sm">
          Discovery is taking longer or its status could not be checked. The
          existing job is retained.
          <Button variant="link" onClick={discovery.checkAgain}>
            Check again
          </Button>
          <Button variant="link" disabled={locked} onClick={onRestart}>
            Restart discovery
          </Button>
        </div>
      )}
      {message && (
        <p role="status" className="text-sm">
          {message}
        </p>
      )}
    </>
  )
}
